(() => {
    const $menu = document.querySelectorAll('.employee-handbook-menu');
    const $subMenuWraps = document.querySelectorAll('.employee-handbook-menu .menu-item-has-children');

    if (!$subMenuWraps) return;

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        const $activeSubMenuWraps = document.querySelectorAll('.employee-handbook-menu .menu-item-has-children.active');
        const $subMenuBack = $subMenuWrap.querySelector('.sub-menu-back');

        if ($activeSubMenuWraps) {
            $activeSubMenuWraps.forEach($activeSubMenuWrap => {
                if ($activeSubMenuWrap.querySelector(`#${$subMenuWrap.id}`)) return;

                disableSubMenu($activeSubMenuWrap, $subMenuToggle);
            });
        }

        $subMenuWrap.classList.add('active');

        $subMenuToggle.setAttribute('aria-expanded', 'true');
        $subMenuToggle.setAttribute('aria-expanded', 'true');

        $subMenuBack.setAttribute('aria-expanded', 'true');
        $subMenuBack.setAttribute('aria-expanded', 'true');
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        const $subMenuBack = $subMenuWrap.querySelector('.sub-menu-back');

        $subMenuWrap.classList.remove('active');

        $subMenuToggle.setAttribute('aria-expanded', 'false');
        $subMenuToggle.setAttribute('aria-expanded', 'false');

        $subMenuBack.setAttribute('aria-expanded', 'false');
        $subMenuBack.setAttribute('aria-expanded', 'false');
    };

    $subMenuWraps.forEach($subMenuWrap => {
        const $subMenuToggle = $subMenuWrap.querySelector('.menu-item-link');
        const $subMenu = $subMenuWrap.querySelector('.sub-menu');
        const $subMenuBack = $subMenuWrap.querySelector('.sub-menu-back');

        if (!$subMenuToggle || !$subMenu) return;

        $subMenuToggle.addEventListener('click', e => {
            e.preventDefault();
            
            if ($subMenuWrap.classList.contains('active')) {
                disableSubMenu($subMenuWrap, $subMenuToggle);
            } else {
                enableSubMenu($subMenuWrap, $subMenuToggle);
            }
        });

        $subMenuBack.addEventListener('click', e => {
            e.preventDefault();

            disableSubMenu($subMenuWrap, $subMenuToggle);
        })
    });
})();
